import React, { useState } from "react";
import { ReactComponent as FilePresent } from "../../../assets/novosicones/file_present_black_24dp.svg";
import { getTermos } from "../../../services/termo";
import ModalBanner from "../../ModalBanner";
import Termo from "../../AccessTherm/TermoPDF";
import Politicas from "../../AccessTherm/PoliticaPDF";
import CloseButtom from "../../Reutilizaveis/CloseButton";
import { Spinner } from "../../StyledComponent";
import { ReactComponent as DownloadIcon } from "../../../assets/novosicones/Termos/DownloadIcon.svg";

import "./styles.scss";

const TermosDeUso = ({ tema }) => {
  const [showBanner, setShowBanner] = useState(false);

  const [termos, setTermos] = useState([]);

  const [readTermo, setReadTermo] = useState(false);

  const [readPoliticas, setReadPoliticas] = useState(false);

  const [loading, setLoading] = useState(false);

  async function getTermosPoliticas() {
    setLoading(true);

    let resultGetTermos = "";
    try {
      resultGetTermos = await getTermos();
      setTermos(resultGetTermos);
      setLoading(false);
      setShowBanner(true);
    } catch (error) {
      return [];
    }
  }

  return (
    <>
      {showBanner && !loading && (
        <ModalBanner
          showBanner={showBanner}
          setShowBanner={setShowBanner}
          alinhamento={"flex-end !important"}
        >
          {readTermo && (
            <Termo
              termosDeAcesso={termos}
              readOnly={true}
              setCloseModal={setReadTermo}
            />
          )}
          {readPoliticas && (
            <Politicas
              termosDeAcesso={termos}
              readOnly={true}
              setCloseModal={setReadPoliticas}
            />
          )}
          <div className="containerBanner centralized-column termosOut">
            <div className="termosDeUso">
              <span
                className="termosDeUso__closeBanner"
                onClick={() => {
                  setShowBanner(!showBanner);
                }}
              >
                <CloseButtom corBackground={"#ffffff"} />
              </span>
              <div
                className="centralized-space-evenly termosOut__content"
                // style={{ width: "100%" }}
              >
                <div className="centralized termosDeUso__titulo">
                  <FilePresent
                    style={{
                      fill: tema.primaryColor,
                      marginLeft: "10px",
                      width: "50px",
                      height: "50px",
                    }}
                  />
                  <div className="centralized-column termosDeUso__titulo">
                    <span>Termos de uso do site:</span>
                    <span style={{ cursor: "auto", textDecoration: "none" }}>
                      Normas de utilização das plataforma:
                    </span>
                  </div>
                </div>
                <div className="centralized-column termosDeUso__btnTermos">
                  <div>
                    <span className="centralized-column termosDeUso__btnTermos__status">
                      Status: entendi e concordo
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setReadTermo(true);
                      setReadPoliticas(false);
                    }}
                    style={{
                      border: `2px solid ${tema.primaryColor}`,
                      color: tema.primaryColor,
                    }}
                  >
                    TERMOS E CONDIÇÕES
                  </button>
                  <a
                    href={termos[0].UriPdf}
                    target="_blank"
                    rel="noreferrer"
                    className="centralized"
                    download
                    style={{ color: tema.primaryColor }}
                  >
                    Fazer o download
                    <DownloadIcon
                      style={{
                        width: "14px",
                        height: "14px",
                        marginLeft: "5px",
                      }}
                    />
                  </a>
                </div>
                <div className="centralized-column termosDeUso__btnTermos">
                  <div>
                    <span className="centralized-column termosDeUso__btnTermos__status">
                      Status: entendi e concordo
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setReadTermo(false);
                      setReadPoliticas(true);
                    }}
                    style={{
                      border: `2px solid ${tema.primaryColor}`,
                      color: tema.primaryColor,
                    }}
                  >
                    POLÍTICAS DE PRIVACIDADE
                  </button>
                  <a
                    href={termos[1].UriPdf}
                    target="_blank"
                    rel="noreferrer"
                    className="centralized"
                    download
                    style={{ color: tema.primaryColor }}
                  >
                    Fazer o download
                    <DownloadIcon
                      style={{
                        width: "14px",
                        height: "14px",
                        marginLeft: "5px",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ModalBanner>
      )}
      <div className="footer__inner centralized-space-between">
        {loading && <Spinner />}
        {!loading && (
          <span
            className="centralized"
            style={{ color: tema.primaryColor }}
            onClick={() => {
              getTermosPoliticas();
            }}
          >
            TERMOS DE USO DO SITE{" "}
            <FilePresent style={{ fill: "#ffffff", marginLeft: "10px" }} />
          </span>
        )}
      </div>
    </>
  );
};

export default TermosDeUso;
